// Mock image data using placeholder images
const captions = [
  'A beautiful sunset over the mountains',
  'City lights at night',
  'Morning coffee vibes',
  'Nature at its finest',
  'Urban exploration',
  'Weekend adventures',
  'Golden hour photography',
  'Street art discovery',
  'Peaceful moments',
  'Travel memories',
  'Artistic perspective',
  'Daily inspiration',
];

const heights = [300, 400, 350, 450, 380, 420, 360, 440, 320, 480];

export const generateMockImages = (count, startIndex = 0) => {
  return Array.from({ length: count }, (_, i) => {
    const index = startIndex + i;
    const height = heights[index % heights.length];
    // Using seed for consistent images
    return {
      id: `mock-${index}-${Math.random().toString(36).substr(2, 9)}`,
      src: `https://picsum.photos/seed/${index + 100}/400/${height}`,
      name: `photo_${index + 1}.jpg`,
      title: `Post #${index + 1}`,
      caption: captions[index % captions.length],
      uploadedAt: new Date(Date.now() - index * 3600000).toISOString(),
    };
  });
};

export const IMAGES_PER_PAGE = 6;
export const MAX_IMAGES = 100;
